// Hapus semua static import untuk komponen halaman.
// import Home from '../views/Home.vue'
// import After_sale from '../views/After_sale.vue'
// import Testdriveveloz from '../views/testdriveavanzaveloz.vue'  //20211119-RD
// import Testdriveallnewveloz from '../views/testdriveavanzaveloz.vue' //20211119-RD
// import After_sale_detail from '../views/after_sale_detail.vue'
// import Promo from '../views/Promo.vue'
// import Trade_in from '../views/Trade_in.vue'
// import Booking_service from '../views/booking_service.vue'
// import Sparepart from '../views/spare_part.vue'
// import Compare_car from '../views/compare_car.vue'
// import Contact_us from '../views/contact_us.vue'
// import Credit_simulation from '../views/credit_simulation.vue'
// import Dashboard_member from '../views/dashboard_member.vue'
// import Detail_product from '../views/details_product.vue'
// import Download_brochure from '../views/download_brochure.vue'
// import Find_dealer from '../views/find_dealer.vue'
// import Find_dealer_detail from '../views/find_dealer_detail'
// import Nasmoco_journey from '../views/nasmoco_journey.vue'
// import News_read from '../views/news_read.vue'
// import Order_info from '../views/order_info.vue'
// import Order_success from '../views/order_success.vue'
// import Order from '../views/order.vue'
// import Pricelist_page from '../views/pricelist_page.vue'
// import Single_page from '../views/single_page.vue'
// import Test_drive from '../views/test_drive.vue'
// import Nasmoco_Club from '../views/nasmoco_club'
// import Nasmoco_Club_Detail from '../views/nasmoco_club_detail'
// import Leadsales from '../views/Leadsales.vue'
// import Career from '../views/Career.vue'
// import JobDetail from '../views/JobDetail.vue'
// import Career_detail from '../views/career_detail.vue'
// import Career_news from '../views/career_news.vue'
// import Career_Faq from '../views/career_faq.vue'
// import CareerContact from '../views/career_contact.vue'


// //detail transaksi
// import Detail_booking_order from '../views/detail_booking_order'
// import Detail_booking_service from '../views/detail_booking_service'
// import Detail_test_drive from '../views/detail_test_drive'
// import Detail_trade_in from '../views/detail_trade_in'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue'),
    meta: {
      mainLayout: true
    }
  },
  {
    path: '/after-sales',
    name: 'After-sale',
    component: () => import(/* webpackChunkName: "after-sale" */ '@/views/After_sale.vue'),
    meta: {
      mainLayout: true
    },
  },
  {
    path: '/testdriveveloz',
    name: 'Testdriveveloz',
    component: () => import(/* webpackChunkName: "test-drive" */ '@/views/testdriveavanzaveloz.vue'),
    meta: {
      mainLayout: true
    },
  },
  {
    path: '/nasmoco-club',
    name: 'nasmoco_club',
    component: () => import(/* webpackChunkName: "nasmoco-club" */ '@/views/nasmoco_club.vue'),
    meta: {
      mainLayout: true
    },
  },
  {
    path: '/nasmoco-club/:link',
    name: 'nasmoco_club_detail',
    component: () => import(/* webpackChunkName: "nasmoco-club" */ '@/views/nasmoco_club_detail.vue'),
    meta: {
      mainLayout: true
    },
  },
  {
    path: '/promo',
    name: 'Promo',
    component: () => import(/* webpackChunkName: "promo" */ '@/views/Promo.vue'),
    meta: {
      mainLayout: true
    }
  },
  {
    path: '/trade-in',
    name: 'Trade_in',
    component: () => import(/* webpackChunkName: "trade-in" */ '@/views/Trade_in.vue'),
    meta: {
      mainLayout: true
    }
  },
  {
    path: '/lead-sales*',
    name: 'Leadsales',
    component: () => import(/* webpackChunkName: "leads" */ '@/views/Leadsales.vue'),
    meta: {
      mainLayout: true
    }
  },
  {
    path: '/generator-lead',
    name: 'GenerateLeadLink',
    component: () => import(/* webpackChunkName: "generator" */ '@/views/GenerateLeadLink.vue'),
    meta: {
      mainLayout: true
    }
  },
  {
    path: '/booking-service',
    name: 'Booking_service',
    component: () => import(/* webpackChunkName: "booking" */ '@/views/booking_service.vue'),
    meta: {
      mainLayout: true
    }
  },
  {
    path: '/sparepart-accesoris',
    name: 'Sparepart',
    component: () => import(/* webpackChunkName: "sparepart" */ '@/views/spare_part.vue'),
    meta: {
      mainLayout: true
    }
  },
  {
    path: '/compare-car',
    name: 'Compare_car',
    component: () => import(/* webpackChunkName: "compare" */ '@/views/compare_car.vue'),
    meta: {
      mainLayout: true
    }
  },
  {
    path: '/contact-us',
    name: 'Contact_us',
    component: () => import(/* webpackChunkName: "contact" */ '@/views/contact_us.vue'),
    meta: {
      mainLayout: true
    }
  },
  {
    path: '/credit-simulation',
    name: 'Credit_simulation',
    component: () => import(/* webpackChunkName: "credit" */ '@/views/credit_simulation.vue'),
    meta: {
      mainLayout: true
    }
  },
  {
    path: '/dashboard-member',
    name: 'Dashboard_member',
    component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard_member.vue'),
    meta: {
      memberLayout: true
    }
  },

  {
    path: '/brochure',
    name: 'Download_brochure',
    component: () => import(/* webpackChunkName: "brochure" */ '@/views/download_brochure.vue'),
    meta: {
      mainLayout: true
    }
  },
  {
    path: '/find-dealer',
    name: 'Find_dealer',
    component: () => import(/* webpackChunkName: "dealer" */ '@/views/find_dealer.vue'),
    meta: {
      mainLayout: true
    }
  },
  {
    path: '/find-dealer/:link',
    name: 'Find_dealer_detail',
    component: () => import(/* webpackChunkName: "dealer" */ '@/views/find_dealer_detail.vue'),
    meta: {
      mainLayout: true
    }
  },
  {
    path: '/nasmoco-journey',
    name: 'Nasmoco_journey',
    component: () => import(/* webpackChunkName: "journey" */ '@/views/nasmoco_journey.vue'),
    meta: {
      mainLayout: true
    }
  },

  {
    path: '/order-info',
    name: 'Order_info',
    component: () => import(/* webpackChunkName: "order" */ '@/views/order_info.vue'),
    meta: {
      orderLayout: true
    }
  },
  {
    path: '/order-success',
    name: 'Order_success',
    component: () => import(/* webpackChunkName: "order" */ '@/views/order_success.vue'),
    meta: {
      orderLayout: true
    }
  },
  {
    path: '/order',
    name: 'Order',
    component: () => import(/* webpackChunkName: "order" */ '@/views/order.vue'),
    meta: {
      orderLayout: true
    }
  },
  {
    path: '/price-list',
    name: 'Pricelist_page',
    component: () => import(/* webpackChunkName: "pricelist" */ '@/views/pricelist_page.vue'),
    meta: {
      mainLayout: true
    }
  },
  {
    path: '/test-drive',
    name: 'Test_drive',
    component: () => import(/* webpackChunkName: "test-drive" */ '@/views/test_drive.vue'),
    meta: {
      mainLayout: true
    }
  },
  {
    path: '/after-sales/:link',
    name: 'After_sale_detail',
    component: () => import(/* webpackChunkName: "after-sale" */ '@/views/after_sale_detail.vue'),
    meta: {
      mainLayout: true
    },
  },
  {
    path: '/info/:profil',
    name: 'Single_page',
    component: () => import(/* webpackChunkName: "single-page" */ '@/views/single_page.vue'),
    meta: {
      mainLayout: true
    }
  },
  {
    path: '/news/:link',
    name: 'News_read',
    component: () => import(/* webpackChunkName: "news" */ '@/views/news_read.vue'),
    meta: {
      mainLayout: true
    }
  },
  {
    path: '/bookingorder/detail/:id',
    name: 'Detail_booking_order',
    component: () => import(/* webpackChunkName: "details" */ '@/views/detail_booking_order.vue'),
    meta: {
      mainLayout: true
    }
  },
  {
    path: '/bookingservice/detail/:id',
    name: 'Detail_booking_service',
    component: () => import(/* webpackChunkName: "details" */ '@/views/detail_booking_service.vue'),
    meta: {
      mainLayout: true
    }
  },
  {
    path: '/testdrive/detail/:id',
    name: 'Detail_test_drive',
    component: () => import(/* webpackChunkName: "details" */ '@/views/detail_test_drive.vue'),
    meta: {
      mainLayout: true
    }
  },
  {
    path: '/tradein/detail/:id',
    name: 'Detail_trade_in',
    component: () => import(/* webpackChunkName: "details" */ '@/views/detail_trade_in.vue'),
    meta: {
      mainLayout: true
    }
  },
  {
    path: '/test-veloz',
    name: 'Testdriveallnewveloz',
    component: () => import(/* webpackChunkName: "test-drive" */ '@/views/testdriveavanzaveloz.vue'),
    meta: {
      mainLayout: true
    }
  },
  {
    path: '/career',
    name: 'Career',
    component: () => import(/* webpackChunkName: "career" */ '@/views/Career.vue'),
    meta: {
      mainLayout: true
    }
  },
  {
    path: '/job/:id',
    name: 'JobDetail',
    component: () => import(/* webpackChunkName: "career" */ '@/views/JobDetail.vue'),
    meta: {
      mainLayout: true
    }
  },
  {
    path: '/career-detail/:link',
    name: 'Career_detail',
    component: () => import(/* webpackChunkName: "career" */ '@/views/career_detail.vue'),
    meta: {
      mainLayout: true
    }
  },
  {
    path: '/career-news/:link',
    name: 'career_news',
    component: () => import(/* webpackChunkName: "career" */ '@/views/career_news.vue'),
    meta: {
      mainLayout: true
    }
  },
  {
    path: '/career-faq',
    name: 'career_faq',
    component: () => import(/* webpackChunkName: "career" */ '@/views/career_faq.vue'),
    meta: {
      mainLayout: true
    }
  },
  {
    path: '/career/contact',
    name: 'CareerContact',
    component: () => import(/* webpackChunkName: "career" */ '@/views/career_contact.vue'),
    meta: {
      mainLayout: true
    }
  },
  {
    path: '/:link',
    name: 'Detail_car',
    component: () => import(/* webpackChunkName: "product" */ '@/views/details_product.vue'),
    meta: {
      mainLayout: true
    },
  },
  // 20251119-RD: Komentar validasi customer sementara
  // {
  //   path: '/validasi-customer',
  //   name: 'ValidasiCustomer',
  //   component: () => import(/* webpackChunkName: "validasi-customer" */ '../views/ValidasiCustomer.vue'),
  //   meta: {
  //     mainLayout: true
  //   },
  //   beforeEnter: (to, from, next) => {
  //     // --- PERLINDUNGAN RUTE ---
  //     // Tentukan kode rahasia yang Anda inginkan.
  //     // Sebaiknya, kode ini disimpan di environment variable untuk keamanan.
  //     const KODE_RAHASIA = '729y98';

  //     // Cek apakah token dari query string (?token=xxxx) cocok.
  //     if (to.query.token === KODE_RAHASIA) {
  //       // Jika cocok, izinkan akses ke halaman.
  //       next();
  //     } else {
  //       // Jika tidak cocok atau tidak ada, alihkan ke halaman utama.
  //       next({ name: 'Home' });
  //     }
  //   }
  // }
]

export { routes }
